// import { useCallback, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
// import { getRequestAsync, postRequestAsync } from '../../../common/genericAPIs'
// import { setLoader, setSnackbar } from '../../../redux/common'
// import { setLegalConfigs } from '../../../redux/login'
import LoginForm from '../../../common/components/LoginForm'
// import { getLegalConsents, legalConfigCodes } from '../../../utils/consent'
import styles from '../Login.module.scss'
import { Card } from 'sfy-react'
import { useCallback } from 'react'

const InitialDetails = ({ handleOnSSOLogin, handleOnRequestOTP, isDisabled }) => {
  // const dispatch = useDispatch()

  // const translatedData = useSelector((state) => state.common.translatedData)
  // const appConfigDetails = useSelector((state) => state.common.appConfigDetails)
  const legalConfigs = useSelector((state) => state.login.legalConfigs)

  // const [loginDetails, setLoginDetails] = useState({})
  // const [loginPageDetails, setLoginPageDetails] = useState({})

  // useEffect(() => {
  //   setLoginDetails({
  //     ...loginPageDetails,
  //     title: loginPageDetails?.title || appConfigDetails.loginOption.loginHeading,
  //     loginSubtext: loginPageDetails?.subtitle || appConfigDetails.loginOption.loginSubTxt,
  //     loginSubheadingText: appConfigDetails.loginOption.loginSubHeading,
  //     loginStorePlanText: String(loginPageDetails?.newCustomerHelp || appConfigDetails.loginOption?.loginStorePlan || '').replace(
  //       '@storeLink',
  //       window.location.origin + '/store'
  //     ),
  //     loginAssistance: `${translatedData.login.completeAssistance} ${window.clientName} ${translatedData.login.devices}`,
  //   })
  // }, [loginPageDetails, appConfigDetails, translatedData])

  const LoginHeading = useCallback(
    ({ wordBreak, title }) => (
      <div className={`${styles['heading']}`}>
        {wordBreak ? (
          title.split(' ').map((word, index) => <div key={'key' + index} />)
        ) : (
          <h3 dangerouslySetInnerHTML={{ __html: title }} />
        )}
      </div>
    ),
    []
  )

  return (
    <>
      {<LoginHeading title={'Sign In To Continue'} />}
      <Card className={styles['login-card']}>
        <LoginForm
          handleOnSSOLogin={handleOnSSOLogin}
          handleOnRequestOTP={handleOnRequestOTP}
          isDisabled={isDisabled}
          legalConfigs={legalConfigs}
        />
      </Card>
    </>
  )
}

export default InitialDetails
